module.exports = __webpack_public_path__ + "img/diia-business.f08fd766.svg";